import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { LOGO_ALT, LOGO_URL } from '../data/site';
const links = [{
  to: '/services',
  label: 'Services'
}, {
  to: '/research',
  label: 'Research'
}, {
  to: '/people',
  label: 'People'
}, {
  to: '/contact',
  label: 'Contact'
}];
export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  return <header className="sticky top-0 z-40 border-b border-ink-200 bg-paper/90 backdrop-blur-sm" data-id="element-82" data-mp="qwng6by85x4p">
      <div className="mx-auto flex h-20 max-w-6xl items-center justify-between gap-6 px-6 lg:px-10" data-id="element-83" data-mp="14wf00tbfa7qm">
        <Link to="/" aria-label="Research Science Group — home" className="flex h-14 shrink-0 items-center overflow-hidden focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-4 focus-visible:ring-offset-paper" data-id="element-84" data-mp="zxbvd9zcu3j6">
          {/* The source file carries ~26% vertical padding, so the image is
              oversized and clipped by this box to make the mark read larger. */}
          <img src={LOGO_URL} alt={LOGO_ALT} width={1372} height={470} className="-ml-[18px] h-[104px] w-auto shrink-0 mix-blend-multiply sm:-ml-[22px] sm:h-[124px]" data-id="element-85" data-mp="2ehlorgpqi0mx" />
        </Link>

        <nav aria-label="Primary" className="hidden items-center gap-8 md:flex" data-id="element-86" data-mp="1qtc6gorqbv0j">
          {links.map(link => <NavLink key={link.to} to={link.to} className={({
          isActive
        }) => ['relative py-1 text-sm transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-4 focus-visible:ring-offset-paper', isActive ? 'text-ink-950' : 'text-ink-500 hover:text-ink-900'].join(' ')} data-id="element-87" data-mp="1vrvx32h9puz8">
              {({
            isActive
          }) => <>
                  {link.label}
                  <span aria-hidden="true" className={['absolute -bottom-[26px] left-0 h-px w-full bg-accent transition-opacity duration-150 ease-out', isActive ? 'opacity-100' : 'opacity-0'].join(' ')} data-id="element-88" data-mp="10251qxwqfdud" />
                </>}
            </NavLink>)}
        </nav>

        <button type="button" onClick={() => setOpen(value => !value)} aria-expanded={open} aria-controls="mobile-nav" className="-mr-2 inline-flex h-10 w-10 items-center justify-center rounded-sm text-ink-700 transition-colors duration-150 ease-out hover:text-ink-950 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent md:hidden" data-id="element-89" data-mp="h3j09hxazkpx">
          {open ? <XIcon className="h-5 w-5" data-id="element-90" data-mp="22hf1gkdgonp1" /> : <MenuIcon className="h-5 w-5" data-id="element-91" data-mp="22g3vqf0gh5va" />}
          <span className="sr-only" data-id="element-92" data-mp="2a04uh1byu626">{open ? 'Close menu' : 'Open menu'}</span>
        </button>
      </div>

      {open && <nav id="mobile-nav" aria-label="Primary mobile" className="border-t border-ink-200 bg-paper md:hidden" data-id="element-93" data-mp="2ezhny4xcebdq">
          <ul className="mx-auto max-w-6xl px-6" data-id="element-94" data-mp="211j9kzj0uey8">
            {links.map(link => <li key={link.to} className="border-b border-ink-100 last:border-0" data-id="element-95" data-mp="251bodtz0dhc1">
                <Link to={link.to} onClick={() => setOpen(false)} className={['block py-4 text-[15px]', location.pathname === link.to ? 'text-ink-950' : 'text-ink-500'].join(' ')} data-id="element-96" data-mp="2sr618bjbv5wa">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </nav>}
    </header>;
}